// Google Calendar API integration
const GOOGLE_CLIENT_ID = '287925460445-s92noni4s5u9pdf8fdsbmr6bccbrunkv.apps.googleusercontent.com';
const GOOGLE_API_KEY = 'AIzaSyBNlYH01_9Hc5S1J9vuFmu2nUqBZJNAXxs'; // Add your API key here
const REDIRECT_URI = window.location.origin + '/google-callback.html';
const SCOPES = 'https://www.googleapis.com/auth/calendar';

// Load the Google API client library
function loadGoogleApi() {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/api.js';
    script.onload = () => {
      window.gapi.load('client:auth2', () => {
        window.gapi.client.init({
          apiKey: GOOGLE_API_KEY,
          clientId: GOOGLE_CLIENT_ID,
          discoveryDocs: ['https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest'],
          scope: SCOPES
        }).then(resolve).catch(reject);
      });
    };
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

// Add TypeScript interface for the global gapi object
declare global {
  interface Window {
    gapi: any;
  }
}

// Store tokens in localStorage
const TOKEN_KEY = 'googleCalendarToken';

interface GoogleCalendarToken {
  access_token: string;
  refresh_token?: string;
  expires_at: number;
}

const googleCalendarService = {
  // Get authorization URL
  getAuthUrl(): string {
    const url = new URL('https://accounts.google.com/o/oauth2/v2/auth');
    url.searchParams.append('client_id', GOOGLE_CLIENT_ID);
    url.searchParams.append('redirect_uri', REDIRECT_URI);
    url.searchParams.append('response_type', 'code');
    url.searchParams.append('scope', SCOPES);
    url.searchParams.append('access_type', 'offline');
    url.searchParams.append('prompt', 'consent');
    
    return url.toString();
  },

  // Check if we have a valid token
  isAuthenticated(): boolean {
    // For demo purposes, always return true if Google Calendar is selected
    // In a real implementation, this would check for a valid token
    return true;
  },

  // Exchange code for token
  async exchangeCodeForToken(code: string): Promise<boolean> {
    try {
      // In a real implementation, this would be a server-side call
      // For demo purposes, we'll simulate the token exchange
      const token: GoogleCalendarToken = {
        access_token: 'simulated_access_token_' + Math.random().toString(36).substring(2),
        refresh_token: 'simulated_refresh_token',
        expires_at: Date.now() + 3600 * 1000 // 1 hour
      };
      
      localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
      return true;
    } catch (error) {
      console.error('Error exchanging code for token:', error);
      return false;
    }
  },

  // Add event to Google Calendar
  async addEvent(event: any): Promise<any> {
    console.log('Adding event to Google Calendar:', event);
    
    try {
      // Load Google API if not already loaded
      if (!window.gapi) {
        await loadGoogleApi();
      }
      
      // Sign in the user
      const authInstance = window.gapi.auth2.getAuthInstance();
      if (!authInstance.isSignedIn.get()) {
        await authInstance.signIn();
      }
      
      // Format event for Google Calendar API
      const googleEvent = {
        summary: event.title || 'Salon Appointment',
        location: event.location || 'Bella Vista Salon & Spa',
        description: event.description || 'Appointment from Bella Vista Salon & Spa',
        start: {
          dateTime: event.startTime.toISOString(),
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        end: {
          dateTime: event.endTime.toISOString(),
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        attendees: event.attendees?.map((email: string) => ({ email })) || []
      };
      
      console.log('Formatted Google Calendar event:', googleEvent);
      
      // Insert the event directly using the Google Calendar API
      const response = await window.gapi.client.calendar.events.insert({
        calendarId: 'primary',
        resource: googleEvent
      });
      
      console.log('Event created: ', response.result);
      return response.result;
    } catch (error) {
      console.error('Error adding event to Google Calendar:', error);
      
      // Fall back to the URL method if the API fails
      const eventTitle = encodeURIComponent(event.title || 'Salon Appointment');
      const startDate = event.startTime.toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
      const endDate = event.endTime.toISOString().replace(/[-:]/g, '').replace(/\.\d+/, '');
      const details = encodeURIComponent(event.description || 'Appointment from Bella Vista Salon & Spa');
      const location = encodeURIComponent(event.location || 'Bella Vista Salon & Spa');
      
      const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${eventTitle}&dates=${startDate}/${endDate}&details=${details}&location=${location}&sf=true&output=xml`;
      
      window.open(googleCalendarUrl, '_blank');
      
      return {
        success: true,
        fallbackMethod: true,
        message: 'Opened event creation page in Google Calendar'
      };
    }
  },
  
  // Disconnect from Google Calendar
  disconnect(): void {
    localStorage.removeItem(TOKEN_KEY);
  }
};

export default googleCalendarService;
